import {
  ProspectApiResponseResult,
  ProspectDetailsResponse,
  ProspectPortfolioDetailsResponse,
} from './types';

export type State = {
  selectedClientId: string | null;
  searchResults: Array<ProspectApiResponseResult>;
  searchResultsCount: number;
  portfolios: Array<ProspectPortfolioDetailsResponse>;
  prospectPortfoliosIsLoading: boolean;
  prospectDetails: ProspectDetailsResponse | null;
};

export const state: State = {
  selectedClientId: null,
  searchResults: [] as Array<ProspectApiResponseResult>,
  searchResultsCount: 0,
  portfolios: [] as Array<ProspectPortfolioDetailsResponse>,
  prospectPortfoliosIsLoading: false,
  prospectDetails: null,
};
